import React, { Suspense } from 'react';
import Suggest from './Suggest';
import ReactDOM from 'react-dom';
import { ApolloProvider } from '@apollo/client';
import { AppService, AppConfigService } from '@aperza/util';
const appConfig = AppService.appConfig();
export const SuggestLoader = (props) => {
    let { rfType, disableMarketplaceBanner } = props;
    let tdComponentName = 'suggest-center';
    if (rfType == '1104') {
        tdComponentName = 'suggest-center-not-for-sale';
    }
    return (React.createElement("div", null,
        React.createElement(Suggest, { tdId: `td-parts-td-${tdComponentName}`, rfType: rfType, disableMarketplaceBanner: disableMarketplaceBanner })));
};
export const renderSuggestLoader = (apolloClient) => {
    const suggestElement = document.getElementById('suggest-center');
    if (suggestElement) {
        let rfType = suggestElement.getAttribute('data-rf-type');
        ReactDOM.render(React.createElement(ApolloProvider, { client: apolloClient },
            React.createElement(Suspense, { fallback: React.createElement("div", null) },
                React.createElement(SuggestLoader, { rfType: rfType ? rfType : undefined, ...AppConfigService.resolveHeaderConfigurations() }),
                ' ')), suggestElement);
    }
};
